import * as React from 'react';

import BookContentUtils from './../../utils/BookContentUtils';
import { ManningOnline } from 'vbook-ui-components/src/subscriptions/components/manningOnline/ManningOnline';

import "./manning-online-page.scss";
import { AuthProvider } from '../../services/authService/AuthProvider';
import { LoginModule } from '../../modules/LoginModule';
import { ManningOnlineManager } from './ManningOnlineManager';
import { ScrapbookManager } from '../../managers/ScrapbookManager';
import { CreditInfoModule } from '../../features/modals/CreditInfoModule';
import EventUtils from '../../utils/EventUtils';
import { DynamicCodeLoader } from '../../utils/DynamicCodeLoader';
import { Header } from '../../components/misc/Header';
import { ReactUtils } from '../../utils/ReactUtils';
import { GlobalStateInfo } from '../../utils/GlobalStateInfo';
import WebUtils from '../../utils/WebUtils';
import { UserActionTrackerModule } from '../../modules/UserActionTrackerModule';
import { DeploymentType, SourceApp } from 'vbook-ui-components/src/Config';

class ManningOnlinePageClass {
    public isActive: boolean;
    public $mainPageContent: JQuery;

    constructor(){
        this.$mainPageContent = $("#main-page-content");

        this.openMap = this.openMap.bind(this);
        this.showCredits = this.showCredits.bind(this);
        this.onScrapbookVisibilityChanged = this.onScrapbookVisibilityChanged.bind(this);

        this.openScrapbook = this.openScrapbook.bind(this);
        this.openDesktop = this.openDesktop.bind(this);
        this.handleHeaderClick = this.handleHeaderClick.bind(this);
        this.onAdditionalSearchSelected = this.onAdditionalSearchSelected.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onSearchDiscussionsSelected = this.onSearchDiscussionsSelected.bind(this);
        this.onSearchLibrarySelected = this.onSearchLibrarySelected.bind(this);
    }

    public initialize(){
        GlobalStateInfo.setNewMainPageContent('<div class="book-content-loader loader"></div>');
        $(document.body).addClass("manning-online-page");
        $(document.documentElement).addClass("manning-online-page");

        $(".header-additional-search-container").removeClass("hidden");

        this.isActive = true;
        BookContentUtils.updateTitle("manning online");
        BookContentUtils.resetMetaContent();
        BookContentUtils.resetMetaImage();
        
        $(document).trigger("slideMenuCloseRequested");
        $(document).trigger("initializeRequested");

        AuthProvider.isLoggedIn().then(data => {
            if(data && data.loggedIn) {
                const store = ManningOnlineManager.getStore();
                if(GlobalStateInfo.hasSubscription(data.userDetails)){
                    store.subscriptionsEnabled = true;
                    store.username = data.userDetails.email;
                    store.subscriptionId = data.userDetails.subscriptionInfo.subscriptionId;
                    store.subscriptionType = data.userDetails.subscriptionInfo.subscriptionOfferingType;
                    store.isSubscriptionOwner = !data.userDetails.subscriptionInfo.isPartnerSubscription;
                }

                Header.showBrowserHeaderIfNecessary();                

                store.loadLatest().then(() => {
                    EventUtils.setTimeout(() => ManningOnlineManager.showTourIfNeeded(), 2000);
                });
                
                store.onCatalogChange(() => {
                    const $select = $("#additional-search-select");
                    if(store.isLibraryTabSelected()){
                        $select.val($select.find("option[data-library]").val());
                        $("#search-additional-input").attr("placeholder", "search library");
                    }
                    else if(store.isDasboardTabSelected()){
                        $select.val($select.find("option[data-dashboard]").val());
                        $("#search-additional-input").attr("placeholder", "search dashboard");
                    }
                    else if(store.isDiscussionsTabSelected()){
                        $select.val($select.find("option[data-discussions]").val());
                        $("#search-additional-input").attr("placeholder", "search discussions");
                    }
                });

                store.loadRecommendedUsers();
                
                const root = ReactUtils.createRoot(document.querySelector("#main-page-content"));
                root.render(React.createElement(ManningOnline, {store: store, deploymentType: GlobalStateInfo.getDeploymentType(), sourceApp: SourceApp.livebook}));

                store.scrapbookStore.onScrapbookVisibilityChanged(this.onScrapbookVisibilityChanged);
                store.onMapShowRequested(this.openMap);
                store.onCreditsShowRequested(this.showCredits);
                store.onTeamPageRequested(() => {
                    if(store.subscriptionId){
                        const link = GlobalStateInfo.getDeploymentType() == DeploymentType.qa 
                                   ? `https://livebook-qa.manning.com/manning-online-corporate/${store.subscriptionId}`
                                   : `https://livebook.manning.com/manning-online-corporate/${store.subscriptionId}`
                        
                        window.open(link, "_blank");
                    }
                });

                store.onLogAction(data => {
                    UserActionTrackerModule.processSubscriptionsAction(data);
                });

                $(document).on("requestScrapbookOpen", this.openScrapbook);
                $(document).on("requestDesktopOpen", this.openDesktop);

                this.showGreetingsModalIfNecessary();
                this.processPotentialReadingListSharing();

                this.openSubpagePassedThroughQueryParam();

                this.getCreditAmount().then(number => {
                    if(number > 0){
                        GlobalStateInfo.numberOfCredits = number;
                        store.catalogState.credits = number;
                        store.triggerCatalogChange();
                    }
                });

                UserActionTrackerModule.processSubscriptionsAction(`manningOnlinePage`);
            }
            else {
                LoginModule.requestLogin();
            }
        });

        $(document).trigger("manningOnline", ["dashboard", "open-page"]);

        $(document).on("click", "#header-browse-container .header-browse-link", this.handleHeaderClick);
        $(document).on("change", "#additional-search-select", this.onAdditionalSearchSelected);
        $(window).on("resizestop", this.onResize);
        $(document).on("search-discussions-selected", this.onSearchDiscussionsSelected);
        $(document).on("search-library-selected", this.onSearchLibrarySelected);

        this.onResize();
    }

    public getCreditAmount(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            WebUtils.getFromOurBackend(
                WebUtils.getAbsoluteUrl("api/cart/getCreditAmount"),
                data => resolve(data != null && data.quantityCredits ? data.quantityCredits : 0),
                e => {
                    console.log(e);
                    resolve(0);
                }
            );
        });
    }

    private handleHeaderClick(e){
        const link = $(e.target).attr("href");
        if(link && link.indexOf("?") >= 0){
            let query = link.substring(link.indexOf("?"));
            this.openSubpagePassedThroughQueryParam(query);
            e.preventDefault();
            return false;
        }
    }

    private openSubpagePassedThroughQueryParam(query: string = ""){
        const store = ManningOnlineManager.getStore();

        const queryParams = query || document.location.search || "";
        
        if(queryParams.indexOf("show-lists") >= 0){
            store.selectReadingListsTab();
        }
        else if(queryParams.indexOf("show-library") >= 0){
            store.selectLibraryTab();
        }
        else if(queryParams.indexOf("show-dashboard") >= 0){
            store.selectDashboardTab();
        }
        else if(queryParams.indexOf("show-books-library") >= 0){
            store.selectLibraryBooksTab();
        }
        else if(queryParams.indexOf("show-lp-library") >= 0){
            store.selectLibraryLpTab();
        }
        else if(queryParams.indexOf("show-audio") >= 0){
            store.selectLibraryAudioTab();
        }
        else if(queryParams.indexOf("show-lv-library") >= 0){
            store.selectLibraryLvTab();
        }
        else if(queryParams.indexOf("show-desktop") >= 0){
            this.openDesktop();
        }
        else if(queryParams.indexOf("show-scrapbook") >= 0
             || queryParams.indexOf("show-notebook") >= 0){
            this.openScrapbook();
        }
        else if(queryParams.indexOf("show-map") >= 0){
            this.openMap()
        }
        else if(queryParams.indexOf("show-chat") >= 0){
            this.openChat();
        }
    }

    public clean(){
        this.isActive = false;
        this.hasScrapbookBeenOpened = false;
        
        $(document.body).removeClass("manning-online-page");
        $(document.documentElement).removeClass("manning-online-page");
        $(document).off("click", "#header-browse-container .header-browse-link", this.handleHeaderClick);
        $(document).off("change", "#additional-search-select", this.onAdditionalSearchSelected);
        $(window).off("resizestop", this.onResize);
        $(document).off("search-discussions-selected", this.onSearchDiscussionsSelected);
        $(document).off("search-library-selected", this.onSearchLibrarySelected);

        try {
            const mainPageContainer = document.querySelector("#main-page-content");
            if(mainPageContainer){
                ReactUtils.unmountAtNode(mainPageContainer);
            }
        }
        catch(e){
            console.log(e);
        }
    }

    private hasScrapbookBeenOpened: boolean = false;
    private onScrapbookVisibilityChanged(isVisible: boolean){
        if(!this.hasScrapbookBeenOpened && isVisible){
            ScrapbookManager.getStore().loadScrapbookShards();
            this.hasScrapbookBeenOpened = true;
        }
    }

    private openMap(){
        //ReaderMapModule.open();
    }

    private showCredits(){
        CreditInfoModule.open();
    }

    private openChat(){
        AuthProvider.isLoggedIn().then(data => {
            if(data.loggedIn){
                //ChatModule.initialize(-1, true);
            }
        })
    }

    private openScrapbook(){
        ScrapbookManager.getStore().toggleShown();
    }

    private openDesktop(){
        ManningOnlineManager.getStore().toggleDesktop();
    }

    private modalSourcePromise: Promise<typeof import('./../../components/modals/ManningOnlineGreetingModal')>;
    private showGreetingsModalIfNecessary(){
        if((window.location.search || "").indexOf("beta-greeting") >= 0){
            this.getModalSource().then(({ManningOnlineGreetingModal}) => {
                ManningOnlineGreetingModal.show()
            });
        }
    }

    private getModalSource(){
        if(!this.modalSourcePromise) {
            this.modalSourcePromise = DynamicCodeLoader.importWebpackModuleWithRetry<typeof import('./../../components/modals/ManningOnlineGreetingModal')>(this.constructModalSourcePromise);
        }
        
        return this.modalSourcePromise;
    }

    private constructModalSourcePromise(){
        return import(/* webpackChunkName: "manningOnlineGreetingModal" */'./../../components/modals/ManningOnlineGreetingModal');
    }

    private processPotentialReadingListSharing(){
        const match = document.location.href.match(/reading-list\/share-([0-9]+)$/);
        if(match == null || match.length < 2){ return; }

        $(document).trigger("requestNotification", "importing reading list ...");

        const readingListId = parseInt(match[1]);
        ManningOnlineManager.getStore().copySharedList(readingListId);
    }

    private onAdditionalSearchSelected(e){
        const value = $(e.target).val();
        const $body = $(document.body);

        if($body.is(".manning-online-library-selected")){
            if(value != "library"){
                $(document.body).addClass("force-standard-search");
                $("#header #search-input").focus();

                $(e.target).val("library");

                e.preventDefault();
                return false;
            }
        }
        else if($body.is(".manning-online-discussions-selected")){
            if(value != "discussions"){
                $(document.body).addClass("force-standard-search");
                $("#header #search-input").focus();

                $(e.target).val("discussions");

                e.preventDefault();
                return false;
            }
        }
        else if($body.is(".manning-online-dashboard-selected")){
            if(value != "dashboard"){
                $(document.body).addClass("force-standard-search");
                $("#header #search-input").focus();

                $(e.target).val("dashboard");

                e.preventDefault();
                return false;
            }
        }
    }

    private onSearchDiscussionsSelected(){
        $(document.body).removeClass("force-standard-search");
        $("#search-additional-input").focus();
    }

    private onSearchLibrarySelected(){
        $(document.body).removeClass("force-standard-search");
        $("#search-additional-input").focus();
    }

    private lastWidth: number = 0;
    private onResize(){
        const $select = $("#additional-search-select");
        const width = $(window).width();

        if(((this.lastWidth <= 690 && width <= 690)
        || (this.lastWidth > 690 && width > 690)) && this.lastWidth > 0) { return; }

        if(width <=690){
            $select.html(`<option value='software engineering' title="all">all</option>
                          <option value='software engineering' title="software engineering">SE</option>
                          <option value='data science' title="data science">DS</option>
                          <option value='operations' title="operations">OPS</option>
                          <option value='discussions' title="discussions" data-discussions>💬</option>
                          <option value='library' title="library" data-library>📚</option>
                          <option value='dashboard' title="dashboard" data-dashboard>📚</option>`);
        }
        else {
            $select.html(`<option value='software engineering' title="all">all</option>
                          <option value='software engineering' title="software engineering">software engineering</option>
                          <option value='data science' title="data science">data science</option>
                          <option value='operations' title="operations">operations</option>
                          <option value='discussions' data-discussions>discussions</option>
                          <option value='library' title='library' data-library>library</option>
                          <option value='dashboard' title='dashboard' data-dashboard>dashboard</option>`);
        }

        const $body = $(document.body);

        if($body.is(".manning-online-library-selected")){
            $select.val($select.find("option[data-library]").val());
            $("#search-additional-input").attr("placeholder", "search library");
        }
        else if($body.is(".manning-online-discussions-selected")){
            $select.val($select.find("option[data-discussions]").val());
            $("#search-additional-input").attr("placeholder", "search discussion");
        }
        else if($body.is(".manning-online-dashboard-selected")){
            $select.val($select.find("option[data-dashboard]").val());
            $("#search-additional-input").attr("placeholder", "search dashboard");
        }

        this.lastWidth = width;
    }
}

export const ManningOnlinePage = new ManningOnlinePageClass();
